import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _types$ROUTER_PUSH$ty;

import * as types from "@/store/constants/types";
export default (_types$ROUTER_PUSH$ty = {}, _defineProperty(_types$ROUTER_PUSH$ty, types.ROUTER_PUSH, function (state, payLoad) {
  state.routeStack.unshift(payLoad);
}), _defineProperty(_types$ROUTER_PUSH$ty, types.ROUTER_GO_BACK, function (state, payLoad) {
  try {
    var pathNumber = Math.abs(payLoad);
    state.routeStack.splice(0, pathNumber);
  } catch (error) {// console.log("ROUTER_GO_BACK error:", error);
  }
}), _defineProperty(_types$ROUTER_PUSH$ty, types.ROUTER_REPLACE, function (state, payLoad) {
  try {
    //先删除第一个，再插入
    state.routeStack.shift();
    state.routeStack.unshift(payLoad);
  } catch (error) {// console.log("ROUTER_REPLACE error:", error);
  }
}), _types$ROUTER_PUSH$ty);